export default "__VITE_ASSET__9869eb21__"